import { z } from "zod";
export const AuthV2Session = z.object({
    id: z.string(),
    refreshToken: z.string(),
    expiresAt: z.coerce.date(),
    createdAt: z.coerce.date(),
    userId: z.string().optional(),
});
